"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEncryptedWidget = void 0;
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var useEncryptedWidget = function () {
    var isAuth = (0, user_1.useIsAuthorized)();
    var _a = (0, useQuery_1.useQuery)({
        canRender: isAuth,
        path: keys_1.GET_REFERRAL_WIDGET,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error;
    return {
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        error: error,
    };
};
exports.useEncryptedWidget = useEncryptedWidget;
